import React, { createContext, useContext } from 'react';
import { useBackgroundTasks, AiTask, AiTaskType } from '@/hooks/useBackgroundTasks';

interface BackgroundTaskContextType {
  tasks: AiTask[];
  pendingCount: number;
  launchTask: (taskType: AiTaskType, input: Record<string, any>) => Promise<string | null>;
}

const BackgroundTaskContext = createContext<BackgroundTaskContextType>({
  tasks: [],
  pendingCount: 0,
  launchTask: async () => null,
});

export const useBackgroundTaskContext = () => useContext(BackgroundTaskContext);

export const BackgroundTaskProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const backgroundTasks = useBackgroundTasks();

  return (
    <BackgroundTaskContext.Provider value={backgroundTasks}>
      {children}
    </BackgroundTaskContext.Provider>
  );
};
